<!--
 * @Author: chenyn 1826650603@qq.com
 * @Date: 2023-09-21 17:21:19
 * @LastEditors: chenyn 1826650603@qq.com
 * @LastEditTime: 2023-10-21 11:36:17
 * @FilePath: \smart-campus-platform-front-vue\src\views\homepage\resource\study-detail.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
      <ItcDetail/>
      <!-- <RoutineDetail v-else /> -->
    </div>
  </template>
  
  <script>
  export default {
    created() {
    },
    components: {
      ItcDetail: () => import("./study-detail/itc-study-detail.vue"),
      RoutineDetail: () => import("./album-detail/routine-album-detail.vue"),
    },
    computed: {
      isTencentCloud() {
        return sessionStorage.getItem("tencentCloud") === "1" ? true : false;
      },
      id() {
        return parseInt(this.$route.query.id)
      }
    },
  };
  </script>
  
  <style scoped lang='scss'>
  </style>
  